import { BaseApi } from '../base';
import { ApiResponse } from '../../../types/api';

export interface IPayInitParams {
  currency?: string // 货币单位
  price?: number // 订单价格，单位：分
  trade_no?: string // 游戏订单号
  is_close_check?: number // 是否关闭校验 默认：0（0：否，1：是）
  token: string
}

export interface IPayPrechargeParams {
  type: number // 支付类型
  role_id: string  // 角色id
  server_id: number // 区服id
  product_id?: string // 商品id, Xsolla支付必传
  product_desc: string // 商品信息描述
  currency?: string // 货币单位
  price: number // 订单价格，单位：分
  trade_no: string // 游戏订单号
  token: string
  return_url: string // 支付成功需要跳转地址
  notify_url?: string // 游戏回调地址
  extra?: string // 扩展标识
  is_pay_behalf?: number // 是否代付 （0:否，1:是）用于网页充值
  is_card?: number // 是否购物车（0:否，1:是）用于网页充值
  oauth_id?: string // 微信jssdk必须传openid
  is_check_trade_no?: number // 是否校验订单 默认0 （0：不校验，1：校验）
  is_refund?: number // 是否退款 默认0 （0：不是，1：是） 来标记退款订单
}

interface IPayCheckParams {
  origin_no: string // 单号
  token: string
}

export class PayApi extends BaseApi {
  // 支付初始化
  async payInit(params: IPayInitParams): Promise<ApiResponse> {
    const { token, ...restParams } = params
    return this.post('/v5/pay-config', restParams, {headers: { Authorization: `Bearer ${token}` } });
  }

  // 生成预订单
  async payPrecharge(params: IPayPrechargeParams): Promise<ApiResponse> {
    const { token, ...restParams } = params
    return this.post('/v5/pay-precharge', restParams, {headers: { Authorization: `Bearer ${token}` } });
  }

  // 订单状态查询
  async payCheck(params: IPayCheckParams, showLoading?: boolean): Promise<ApiResponse> {
    const { token, origin_no } = params
    return this.get(`/v5/pay-check/${origin_no}`, {headers: { Authorization: `Bearer ${token}` }, showLoading });
  }

  // 查询微信open_id
  async getWechatOpenId(): Promise<ApiResponse> {
    return this.get(`https://api.qingcigame.com/wechat/info`, { showLoading: false, noHeader: true });
  }
}